<template>
  <div>
    <h3
      style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      新闻列表
    </h3>
    <el-button type="primary" @click="showNew" style="float:left;" plain>新增</el-button>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%">
      <el-table-column
        fixed
        prop="title"
        label="新闻标题"
      >
      </el-table-column>
      <el-table-column
        prop="pictureUrl"
        label="图片路径">
        <template slot-scope="scope">
          <img :src="common.getPictureUrl(scope.row)" style="height: 120px;">
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="keywords"
        label="关键字"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="是否显示"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status==='y'">显示</span>
          <span v-if="scope.row.status==='n'">不显示</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="createtime"
        label="创建时间"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="新增新闻" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="文章标题" :label-width="formLabelWidth">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="配图" :label-width="formLabelWidth">
          <el-upload
            :action="this.$host+'upload'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="fileList"
            :on-success="uploadSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="关键字" :label-width="formLabelWidth">
          <el-input v-model="form.keywords" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" :label-width="formLabelWidth">
          <el-switch
            style="display: block"
            v-model="form.status"
            active-value="y"
            inactive-value="n"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="显示"
            inactive-text="不显示">
          </el-switch>
        </el-form-item>

        <el-form-item label="文章描述" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="文章内容" :label-width="formLabelWidth">
          <el-form status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <vue-editor v-model="form.content"
                        useCustomImageHandler
                        @imageAdded="this.$common.handleImageAdded">
            </vue-editor>
          </el-form>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button @click="resetForm()">重置</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {VueEditor} from 'vue2-editor'

  export default {
    name: "ArticleList",
    components: {
      VueEditor
    },
    methods: {
      // handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      //   this.$common.handleImageAdded(file, Editor, cursorLocation, resetUploader)
      // },
      showNew() {
        this.dialogFormVisible = true;
        this.form = {};
        // console.log("showNew.fileList:"+JSON.stringify(this.fileList));
        this.fileList = [];
      },
      submit() {
        const self = this
        let postData = self.$qs.stringify(this.form)
        let method = 'save'
        if (self.form.id) {
          method = 'update'
        }
        self.$http.post(self.$host + 'article/' + method,
          postData
        ).then(function (response) {
          self.$common.loginCheck(response.data.content)
          self.tableData = response.data.list;
          self.dialogFormVisible = false
          self.loadData()
        }).catch(e => {
          console.log(e)
        })
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleEdit(row) {
        // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
        this.form = JSON.parse(JSON.stringify(row))
        this.dialogFormVisible = true;

        // this.fileList = new Array(this.getPictureUrl(row));
      },
      handleDelete(row) {
        this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const self = this
          let postData = self.$qs.stringify(row)
          self.$http.post(self.$host + 'article/delete',
            postData
          ).then(function (response) {
            self.$common.loginCheck(response.data.content)
            self.tableData = response.data.list;
            self.dialogFormVisible = false
            self.loadData()
            self.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(e => {
            console.log(e)
            self.$message({
              type: 'error',
              message: '删除失败!'
            });
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        // this.loadData('?pager.offset='+(this.pageSize * this.currentPage));
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.loadData('?pager.offset=' + (this.pageSize * (val - 1)));
      },
      loadData(params) {
        const self = this
        let postData =
          self.$qs.stringify({})
        if (!params) {
          params = '';
        }
        self.$http.post(self.$host + 'article/page' + params,
          postData
        ).then(function (response) {
          self.tableData = response.data.content.records;
          self.currentPage = response.data.content.current;
          self.pageSize = response.data.content.pageSize;
          self.total = response.data.content.total;
        }).catch(e => {
          console.log(e)
        })
      },
      uploadSuccess(response, file, fileList) {
        this.form.image = response.content;
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        tableData: [],
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {},
        formLabelWidth: '120px',
        value4: true,
        htmlContent: '',
        ruleForm: {},
        rules: {},
        currentPage: 1,
        pageSize: 10,
        total: 1,
        dialogVisible: false,
        fileList: [],
        dialogImageUrl: '',
        common:this.$common,
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/NewsManage.vue